/** Градация машин по тому, сколько литров в неё влезет. */

import type { Car } from '@cdf/shared';

export type CarTier = 'off' | 'low' | 'mid' | 'high';

/**
 * Чем больше не хватает топлива, тем надёжнее шаг: запас сверх акционного
 * минимума страхует от неточности датчика.
 *
 * Градация считается от запаса над порогом, а не от абсолютных литров:
 * порог задаётся в настройках, и при его изменении зашитые числа начали бы
 * врать. Пять литров запаса — примерно погрешность указателя на полтиннике.
 */
export function carTier(
  car: Pick<Car, 'missingLiters' | 'eligible'>,
  minLitersForBonus: number,
): CarTier {
  if (!car.eligible) return 'off';
  const margin = car.missingLiters - minLitersForBonus;
  if (margin < 5) return 'low';
  if (margin < 15) return 'mid';
  return 'high';
}

export const TIER_LABEL: Record<CarTier, string> = {
  off: 'не подходит',
  low: 'впритык',
  mid: 'хорошо',
  high: 'отлично',
};

/** Имя CSS-переменной с цветом уровня — карта берёт цвет оттуда же, что и вёрстка. */
export const TIER_VAR: Record<CarTier, string> = {
  off: '--c-tier-off',
  low: '--c-tier-low',
  mid: '--c-tier-mid',
  high: '--c-tier-high',
};
